<header>
  <div class="logo" (click)="goHome()" (keyup)="goHome()" tabindex="0">
     <img src="assets/images/round-logo.svg" alt="Cyber Intelligence House" />
  </div>
  <cep-nav-menu class="nav-menu"></cep-nav-menu>
  <cep-user-greeting></cep-user-greeting>
</header>
